// Product attributes: display-only rows of {name, value} (Author, ISBN, Fabric, Processor…). Mirrors backend/attributes.py.
const lc = (s) => String(s || "").trim().toLowerCase();

/** Per-row problems for the editor: { [index]: message }. Fully empty rows are ignored (dropped on save). */
export function attributeErrors(rows) {
  const errs = {};
  const live = rows.map((r, i) => [r, i]).filter(([r]) => String(r.name).trim() || String(r.value).trim());
  const seen = new Set();
  live.forEach(([r, i]) => {
    const key = `${lc(r.name)}|${lc(r.value)}`;
    if (!String(r.name).trim()) errs[i] = "Name is required.";
    else if (!String(r.value).trim()) errs[i] = "Value is required.";
    else if (seen.has(key)) errs[i] = "Duplicate name and value.";
    seen.add(key);
  });
  if (live.length > 40) errs[-1] = "At most 40 attribute rows.";
  return errs;
}

/** Form rows from API rows, and back. */
export const toFormRows = (attrs) => (attrs || []).map((a) => ({ name: a.name, value: a.value }));
export const toApiRows = (rows) => rows
  .filter((r) => String(r.name).trim() || String(r.value).trim())
  .map((r) => ({ name: String(r.name).trim(), value: String(r.value).trim() }));
